/**
 * 🛍️ **열려 있는 굿즈 편집 칸을 목록에 합친다** — 「목록에 반영」·「🚀 웹에 올리기」·「💾 저장하기」가 같은 함수를 쓴다 (2026-10-21).
 *
 * 예전엔 편집 칸의 내용은 칸 안의 「목록에 반영」을 눌러야만 목록에 들어갔다. 그런데 화면 아래에 늘 떠 있는
 * 「🚀 웹에 올리기」를 바로 누르면 **편집 중인 내용은 빠진 채 게시되고 「✅ 웹에 올렸어요」가 떴다** —
 * 판매처 주소를 넣고 올렸는데 아이 화면은 「스토어 준비 중이에요」 그대로(로컬에서 운영자 할 일을 걸어 보다 찾음).
 * 관리자 원칙도 「저장은 아래 막대 하나」다(메모리 admin-ui-system).
 */
import { storeRowsOf, type GoodsProduct } from "@greg-chick/shared";

/** 편집 칸 → 저장할 모양: 빈 「살 수 있는 곳」 줄은 빼고, 옛 store_url 은 stores 로 옮긴 뒤 비운다. */
export function cleanEdited(editing: GoodsProduct): GoodsProduct {
  // 읽는 곳과 같은 함수(storeRowsOf) — 옛 형식(store_url)으로 저장된 상품의 주소가 사라지지 않게
  const stores = storeRowsOf(editing).filter((r) => r.url.trim());
  return { ...editing, store_url: undefined, stores: stores.length ? stores : undefined };
}

/**
 * 편집 칸이 열려 있으면 그 상품을 목록에 넣은 새 목록. 안 열려 있으면 목록 그대로.
 * `originalId` 는 고치기 시작할 때의 id(id 를 바꿔도 같은 줄을 바꾼다) — 없으면 새 상품이라 끝에 붙인다.
 */
export function withEditing(products: GoodsProduct[], editing: GoodsProduct | null, originalId: string | null): GoodsProduct[] {
  if (!editing) return products;
  const clean = cleanEdited(editing);
  const i = originalId ? products.findIndex((p) => p.id === originalId) : -1;
  if (i < 0) return [...products, clean];
  const next = [...products];
  next[i] = clean;
  return next;
}
